/* eslint-disable no-param-reassign */
import produce from 'immer';
import { SET_CALL_CENTERS } from 'src/actions/callCenterActions';

const initialState = {
  callCenters: null,
};

const callCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CALL_CENTERS: {
      let callCenters;
      if (action.payload?.callCenters) {
        callCenters = action.payload.callCenters;
      } else if (action.payload) {
        callCenters = [action.payload];
      } else {
        callCenters = [];
      }

      return produce(state, (draft) => {
        draft.callCenters = callCenters;
      });
    }
    default: {
      return state;
    }
  }
};

export default callCenterReducer;
